import React from "react";
import "./Loader.css"; // Import the CSS for styling
import logo from '../../assets/images/AL_logo.jpg';
const Loader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader">
      </div>
      <img src={logo} alt="Loading..." className="static-img" />
    </div>
  );
};

export default Loader;
